export default __webpack_public_path__ + "img/f731965db85b7a39c6875afc5c7403c7.png";